import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Assets from "Data/Assets";
import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";
import { Button } from "GameObjects/Button";
import { MusicGameCharacter } from "GameObjects/MusicGame/Character";
import { MusicGameLoopButton } from "GameObjects/MusicGame/Buttons/LoopButton";
import { MusicGameNoLoopButton } from "GameObjects/MusicGame/Buttons/NoLoopButton";
import * as TestJSON from "json/testSong.json";
import { MusicManager } from "Singletons/MusicManager";
// import AudioPreloadManager from "Singletons/AudioPreloadManager";
import { MusicGameTimeline } from "GameObjects/MusicGame/Timeline";
import { MusicGameRecordButton } from "GameObjects/MusicGame/Buttons/RecordButton";
import { MusicGameCountIn } from "GameObjects/MusicGame/CountIn";
import { MusicGameShareButton } from "GameObjects/MusicGame/Buttons/ShareButton";
import { MusicGamePlayButton } from "GameObjects/MusicGame/Buttons/PlayButton";
import { MusicGameTyler } from "GameObjects/MusicGame/Characters/Tyler";
import { MusicGameAmy } from "GameObjects/MusicGame/Characters/Amy";
import { MusicGameHolly } from "GameObjects/MusicGame/Characters/Holly";
import { MusicGameOscar } from "GameObjects/MusicGame/Characters/Oscar";
import { MusicGamePiper } from "GameObjects/MusicGame/Characters/Piper";
import { MusicGameOverlaySpotlight } from "GameObjects/MusicGame/OverlaySpotlight";
import { MusicGameRampedSpotlight } from "GameObjects/MusicGame/RampedSpotlight";
import { MusicGameBackground } from "GameObjects/MusicGame/Background";

export class MusicGame extends HLF.State {
    private readonly _buttons: (HLF.Input.IFocusable & PIXI.Container)[];
    private readonly _characters: MusicGameCharacter[];
    private readonly _timeline: MusicGameTimeline;
    private readonly _subscriptions: string[];

    constructor() {
        super();

        this._buttons = new Array<Button>();

        const bg = this.addChild(new MusicGameBackground());

        const helloText = HLF.PixiUtils.makeText(`Music Game`, Constants.FONT_GEL_MED_35, 35, 0xffffff);
        this.addChild(helloText);
        helloText.y = -350;

        const spotOverlayAmy = this.addChild(new MusicGameOverlaySpotlight({id: 1, name: 'amy'}));
        const spotOverlayOscar = this.addChild(new MusicGameOverlaySpotlight({id: 3, name: 'oscar'}));
        const spotOverlayPiper = this.addChild(new MusicGameOverlaySpotlight({id: 4, name: 'piper'}));
        const spotOverlayTyler = this.addChild(new MusicGameOverlaySpotlight({id: 0, name: 'tyler'}));
        const spotOverlayHolly = this.addChild(new MusicGameOverlaySpotlight({id: 2, name: 'holly'}));
        const spotRampedAmy = this.addChild(new MusicGameRampedSpotlight({id: 1, name: 'amy'}));
        const spotRampedOscar = this.addChild(new MusicGameRampedSpotlight({id: 3, name: 'oscar'}));
        const spotRampedPiper = this.addChild(new MusicGameRampedSpotlight({id: 4, name: 'piper'}));
        const spotRampedTyler = this.addChild(new MusicGameRampedSpotlight({id: 0, name: 'tyler'}));
        const spotRampedHolly = this.addChild(new MusicGameRampedSpotlight({id: 2, name: 'holly'}));

        const amy = this.addChild(new MusicGameAmy({id: 1}));
        const oscar = this.addChild(new MusicGameOscar({id: 3}));
        const piper = this.addChild(new MusicGamePiper({id: 4}));
        const tyler = this.addChild(new MusicGameTyler({id: 0}));
        const holly = this.addChild(new MusicGameHolly({id: 2}));

        spotOverlayHolly.position.set(0, -384);
        spotOverlayTyler.position.set(-350, -384);
        spotOverlayPiper.position.set(350, -384);
        spotOverlayOscar.position.set(140, -384);
        spotOverlayAmy.position.set(-150, -384);

        spotRampedTyler.position.set(-350, -384);
        spotRampedAmy.position.set(-150, -384);
        spotRampedHolly.position.set(0, -384);
        spotRampedOscar.position.set(140, -384);
        spotRampedPiper.position.set(350, -384);

        tyler.position.set(-345, 137);
        amy.position.set(-180, 55);
        holly.position.set(0, 135);
        oscar.position.set(170, 67);
        piper.position.set(315, 130);

        this._characters = [
            tyler,
            amy,
            holly,
            oscar,
            piper,
        ]

        this._timeline = this.addChild(new MusicGameTimeline());
        const loopButton1 = this.addChild(new MusicGameLoopButton({'id': 0}));
        const loopButton2 = this.addChild(new MusicGameLoopButton({'id': 1}));
        const loopButton3 = this.addChild(new MusicGameLoopButton({'id': 2}));
        // const loopButton4 = this.addChild(new MusicGameLoopButton({'id': 4}));
        const noLoopButton = this.addChild(new MusicGameNoLoopButton());
        const recordButton = this.addChild(new MusicGameRecordButton());
        const shareButton = this.addChild(new MusicGameShareButton());
        const playButton = this.addChild(new MusicGamePlayButton());
        const countIn = this.addChild(new MusicGameCountIn());

        loopButton1.position.set(-300, 250);
        loopButton2.position.set(-150, 250);
        loopButton3.position.set(0, 250);
        // loopButton4.position.set(150, 200);
        noLoopButton.position.set(150, 250);
        recordButton.position.set(450, 250);
        shareButton.position.set(450, 0);

        loopButton1.visible = false;
        loopButton2.visible = false;
        loopButton3.visible = false;
        // loopButton4.visible = false;
        noLoopButton.visible = false;
        shareButton.visible = false;
        recordButton.visible = false;

        playButton.position.set(0, 100);
        this._timeline.position.set(0, 250);

        this._buttons = [
            loopButton1,
            loopButton2,
            loopButton3,
            // loopButton4,
            noLoopButton,
            recordButton,
            shareButton,
            playButton,
        ]

        this._subscriptions = [
            //
        ];
    }

    /**
     * Currently acts like a delayed contructor.
     * @param pSize The current window size.
     */
    public init(pSize: PIXI.Point) {
        super.init(pSize);

        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, [
            ...this._characters,
            ...this._buttons,
        ]);
        // AudioPreloadManager.debug = false;
        // AudioPreloadManager.paused = false;

        this.onResize(pSize);
    }

    /**
     * Called when a state is destroyed.
     */
    public destroy(pOptions?: {children?: boolean; texture?: boolean; baseTexture?: boolean;}): void {
        super.destroy(pOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
        PubSub.publishSync(HLF.CLEAR_FOCUS, undefined);
        PubSub.publishSync(HLF.UNREGISTER_ALL_FOCUSABLES, undefined);
    }

    /**
     * Called when the window is resized.
     * @param pSize The new size.
     */
    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    /**
     * Called after load screen has animated out.
     * If no animation is required, simply remove this function.
     * @param pOnComplete Callback when completed.
     */
    public animateIn(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            timeline.to(element.scale, 0.5, {
                x: 1,
                y: 1,
            }, 0.1 * i);
        }
        timeline.call(this.onAnimateInComplete.bind(this));
        timeline.eventCallback(Constants.TWEEN_ONCOMPLETE, pOnComplete);
    }

    /**
     * Called when transition to leave starts.
     * If no animation is required, simply remove this function.
     * @param pOnComplete Callback when completed.
     */
    public animateOut(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            element.interactive = false;
            timeline.to(element.scale, 0.5, {
                x: 0,
                y: 0,
            }, 0.1 * i);
        }
        timeline.eventCallback(Constants.TWEEN_ONCOMPLETE, pOnComplete);
    }

    /**
     * Called once per frame.
     * @param pDeltaTime Time it took to render the previous frame.
     */
    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this._timeline.update(pDeltaTime);
        MusicManager.Instance.update(pDeltaTime / 1000);
        // AudioPreloadManager.update();
        for(let i=0; i<this._characters.length; i++) {
            this._characters[i].update(pDeltaTime);
        }
    }

    private onAnimateInComplete(): void {
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            element.interactive = true;
        }
    }
}
